/** @var { RegExp } */
export const DateRegex = /^[\d]{4}-[\d]{2}-[\d]{2}$/; // YYYY-MM-DD

export const KeywordAndGroupsTableMaxDateColumns = 4;

export const KeywordPositionFeature = {
  LOCAL_3_PACK: 'local_3_pack',
  MAPS: 'maps',

  IMAGE_PACK_RESULTS: 'image_pack_results',
  IMAGE_PACKS: 'image_packs',
  IMAGE: 'image',

  ANSWER_BOX_TYPE: 'answer_box_type',
  ANSWER_BOX: 'answer_box',

  KNOWLEDGE_GRAPH: 'knowledge_graph',

  PEOPLE_ALSO_ASK: 'people_also_ask',

  SHOPPING_BOX: 'shopping_box',

  VIDEO_PACK_RESULTS: 'video_pack_results',
  VIDEO_PACKS: 'video_packs',
  VIDEO: 'video',

  NEWS_PACK_RESULTS: 'news_pack_results',
  NEWS_PACKS: 'news_packs',
  NEWS: 'news',

  EVENTS: 'events',

  BRAND_PACK_RESULTS: 'brand_pack_results',
  BRAND_PACK: 'brand_pack',
};

export const FilterOperator = {
  BETWEEN: 'btwn',
  NOT_IN: 'nin',
  GREATER_THAN: 'gt',
};

export const ApiInclude = {
  KEYWORD: 'keyword',
  KEYWORDS: 'keywords',
  KEYWORD_GROUP: 'keywordGroup',
  KEYWORD_GROUPS: 'keywordGroups',
  WEBSITE: 'website',
  KEYWORD_POSITION_DATE_RANGE: 'keywordPositionDateRange',
};

export const KeywordTrackingTab = {
  OVERVIEW: 'overview',
  KEYWORDS_AND_GROUPS_RANKING: 'kw-group-rank',
  COMPETITOR_BENCHMARK: 'competitor-benchmark',
  COMPETITOR_HIGHER_RANK: 'competitor-higher-rank',
};

export const ApiField = {
  RECORDED_DATE: 'recordedDate',
};

export const ApiIncludeSeparator = ',';

export const ApiFilterSeparator = '|';

export const PreDefinedFilter = {
  ALL: 'All',
  TOP_1: 'Top 1',
  TOP_3: 'Top 3',
  TOP_5: 'Top 5',
  TOP_10: 'Top 10',
  TOP_30: 'Top 30',
  TOP_100: 'Top 100',
  MOVED_UP: 'Moved up',
  MOVED_DOWN: 'Moved down',
};

export const PositionsServiceId = 'positions';

export const TableName = {
  KEYWORDS_AND_GROUPS_RANKING: 'keywords_and_groups_ranking',
};

export const PositionBucket = {
  KEYWORD_POSITIONS_1_TO_3: 'keywordPositions1To3',
  KEYWORD_POSITIONS_4_TO_10: 'keywordPositions4To10',
  KEYWORD_POSITIONS_11_TO_20: 'keywordPositions11To20',
  KEYWORD_POSITIONS_21_TO_40: 'keywordPositions21To40',
  KEYWORD_POSITIONS_41_TO_100: 'keywordPositions41To100',
  GREATER_THAN_100_COUNT: 'greaterThan100Count',
};

export const KeywordGroupNoDataErrorMessage =
  "This Keyword Group doesn't have any data yet. Please return after next scheduled crawl";
